import { createElement, forwardRef, type ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './ParticipantTable.css';

export interface ParticipantTableFillProps {
  children?: ReactNode;
  /**
   * Scroll anchor below the sticky header. Paginated tables still grow to a
   * viewport page of rows via `useParticipantTableViewport`.
   */
  viewportPage?: boolean;
  as?: 'div' | 'section';
  className?: string;
  testId?: string;
}

/** Wrapper every viewport-sized participant table shares. */
export const ParticipantTableFill = forwardRef<HTMLElement, ParticipantTableFillProps>(
  function ParticipantTableFill(
    { children, viewportPage = false, as: Tag = 'div', className, testId },
    ref,
  ) {
    return createElement(
      Tag,
      {
        ref,
        className: classes(
          'participant-table-fill',
          viewportPage && 'participant-table-fill--page',
          className,
        ),
        'data-participant-table-fill': true,
        ...testIdAttr(testId),
      },
      children,
    );
  },
);
